import React, { useEffect, useState } from 'react';
import { classNames } from "../../helpers/classNames";

const Tabs = ({
  tabs,
  tabContainerClass,
  tabNavClass,
  tabButtonClass,
  tabButtonActiveClass,
  tabContentClass,
  ...props
}) => {
  const [selectedTab, setSelectedTab] = useState({})

  const handleTabSelection = (tab = {}) => {
    setTimeout(() => {
      let activeTab = [];
      let filteredTab = tabs.filter((tab) => activeTab.includes(tab._id))[0];
      if (filteredTab) {
        activeTab = [...activeTab.filter((actab) => actab !== filteredTab._id), tab?._id]
      } else {
        activeTab = [...activeTab, tab?._id]
      }
      setSelectedTab(tab);
    }, 100)
  }

  useEffect(() => {
    if (tabs.length) {
      setSelectedTab(tabs[0])
    }
  }, [tabs]);

  return (
    <>
      <div className={classNames("relative flex flex-col items-start", tabContainerClass)}>
        <nav className={classNames("flex overflow-auto gap-2 max-w-full", tabNavClass)}>
          {tabs.map((item, index) => (
            <button
              type="button"
              className={classNames(
                "relative rounded-t-2xl transition-all duration-200 px-4 h-12 whitespace-nowrap text-base font-medium", tabButtonClass,
                (item._id === selectedTab?._id) ? classNames("bg-chestnut-rose text-white", tabButtonActiveClass) : "bg-shades-04 text-gable-green",
              )}
              key={index}
              onClick={() => handleTabSelection(item)}
            >
              {item.name}
            </button>
          ))}
        </nav>
        <div className={classNames("relative w-full py-4", tabContentClass)}>{selectedTab?.component}</div>
      </div>
    </>
  );
};

export default Tabs;